module.exports = __webpack_public_path__ + "media/images/logos/isaac-logo-with-bg-857b9a38f2f989a599db14c8445bfa1a.svg";